// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { ReactNode, useEffect, useRef, useState } from "react"


interface ComponentProps {
    children?: ReactNode,
    height: number
    itemHeight?: number
    show: number,
    style?: any
}



const FadingIonList: React.FC<ComponentProps> = ({
  children,
  height,
  show,
  style
}) => {
  const [isReady, setReady] = useState<boolean>(false)
  const currentStyle = {
    height: `calc(${height}px * ${show})`,
    maxHeight: `calc(${height}px * ${show})`,
    ...(style || {}),
  }
  const ref = useRef<HTMLDivElement>(null)

  const addFadeEffect = (isScrollable: boolean) => {
    if (ref.current !== null) {
      const isScroledlToTop = ref.current.scrollTop === 0;
      const isScrolledToBottom = (ref.current.scrollHeight <= ref.current.clientHeight + ref.current.scrollTop)
      if (!isScrollable) {
        ref.current.classList.remove('overflow-top', 'overflow-bottom')
      }
      ref.current.classList.toggle('overflow-top', !isScroledlToTop)
      ref.current.classList.toggle('overflow-bottom', !isScrolledToBottom)
    }
  }

  useEffect(() => {
    if (!!isReady) { return }
    if (!ref.current) { return }
    const isScrollable = ref.current.scrollHeight > ref.current.clientHeight
    ref.current.classList.toggle('overflow-bottom', true)
    ref.current.addEventListener("scroll", () => addFadeEffect(isScrollable))
    setReady(true)
    return

  }, [isReady])

  return (
    <div className="scrollable" ref={ref} style={{...currentStyle, overflowY: "scroll"}}>
      {(!!isReady) ? children : null}
    </div>
  )   
}


export { FadingIonList }